// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__kQdMP","content":"styles_content__5qj5U"};